import { CaretDownIcon as PhosphorCaretDownIcon } from "@phosphor-icons/react/dist/ssr/CaretDown";

import { createAppIcon } from "@/components/createAppIcon";

export const ExpandIcon = /* @__PURE__ */ createAppIcon(PhosphorCaretDownIcon);
export const DropdownIcon = /* @__PURE__ */ createAppIcon(PhosphorCaretDownIcon);
